'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/ui/utils';
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

/**
 * Multi-step progress bar — N equal-width pills, filled left-to-right
 * based on `currentStep`. Shared by:
 *   - `create-proposal-dialog.tsx` (proposal creation)
 *   - `suggested-outcomes/wizard/SuggestOutcomeWizard.tsx`
 *
 * Originally inline in create-proposal-dialog.tsx; lifted when the
 * Suggested-outcomes wizard adopted the same pattern.
 */
export function StepIndicator(t0) {
  const $ = _c(5);
  const {
    currentStep,
    totalSteps
  } = t0;
  let t1;
  if ($[0] !== currentStep || $[1] !== totalSteps) {
    let t2;
    if ($[3] !== currentStep) {
      t2 = (_, i) => <div key={`step-${String(i)}`} className={cn("h-1.5 flex-1 rounded-full transition-colors", i < currentStep ? "bg-foreground-primary" : "bg-background-tertiary")} />;
      $[3] = currentStep;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = <div className="flex gap-1">{Array.from({
        length: totalSteps
      }, t2)}</div>;
    $[0] = currentStep;
    $[1] = totalSteps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}